export default __webpack_public_path__ + "static/media/ic_llp_16.3c237891.svg";